@if (comparisonService.count() > 0) {
  <div class="comparison-banner" role="region" [attr.aria-label]="'Comparison tray' | t">
    <div class="comparison-banner__inner">
      <div class="comparison-banner__items">
        @for (fabric of comparisonService.fabrics(); track fabric.uuid) {
          <div class="comparison-banner__item">
            <img
              nz-image
              class="comparison-banner__thumb"
              [nzSrc]="fabric.article?.cover?.thumbUrl ?? 'error'"
              [nzFallback]="fallback"
              [alt]="fabric.article?.name ?? ''"
              [nzDisablePreview]="true"
            />
            <div class="comparison-banner__item-info">
              <span class="comparison-banner__item-code">{{ fabric.auxCode }}</span>
              <span class="comparison-banner__item-name">{{ fabric.article?.name }}</span>
            </div>
            <button
              class="comparison-banner__remove"
              nz-button
              nzType="text"
              nzSize="small"
              type="button"
              [attr.aria-label]="'Remove from comparison' | t"
              (click)="remove(fabric)"
            >
              <span nz-icon nzType="close"></span>
            </button>
          </div>
        }
      </div>

      <div class="comparison-banner__actions">
        <span class="comparison-banner__count">
          {{ comparisonService.count() }} {{ 'selected' | t }}
        </span>
        <button
          nz-button
          nzType="primary"
          type="button"
          [disabled]="comparisonService.count() < 2"
          [attr.aria-label]="'Compare selected fabrics' | t"
          (click)="openCompareModal()"
        >
          <span nz-icon nzType="swap"></span>
          {{ 'Compare' | t }}
        </button>
        <button
          nz-button
          nzType="default"
          type="button"
          [attr.aria-label]="'Clear comparison' | t"
          (click)="clear()"
        >
          {{ 'Clear' | t }}
        </button>
      </div>
    </div>
  </div>
}
